import { createProjectApi, createSubprojectApi } from "@org-avp/avp-avengers-project-service-api";
import { environment } from "@org-avp/avp-avengers-ui-shared-environment";
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { prepareHeaders } from "../utils/header.utils";

const baseQueryArgs: Parameters<typeof fetchBaseQuery>[0] = {
  baseUrl: environment.NX_PROJECT_SERVICE_BASE_URL,
  prepareHeaders,
};

export const projectApi: ReturnType<typeof createProjectApi> = createProjectApi(baseQueryArgs);
export const subprojectApi: ReturnType<typeof createSubprojectApi> = createSubprojectApi(baseQueryArgs);
